/** Downscale a dock-arrival label photo before the synchronous Gemini scan. */

export const INBOUND_ARRIVAL_LABEL_SCAN_MAX_LONG_EDGE = 1280;
export const INBOUND_ARRIVAL_LABEL_SCAN_JPEG_QUALITY = 0.72;

function buildDownscaledFilename(): string {
  const stamp = new Date().toISOString().replace(/[:.]/g, "-");
  return `arrival-label-${stamp}.jpg`;
}

export async function prepareInboundArrivalLabelPhoto(file: File): Promise<File> {
  if (file.size === 0) return file;
  try {
    const bitmap = await createImageBitmap(file);
    const longEdge = Math.max(bitmap.width, bitmap.height);
    const alreadySmall =
      longEdge <= INBOUND_ARRIVAL_LABEL_SCAN_MAX_LONG_EDGE &&
      file.type === "image/jpeg" &&
      file.size <= 400_000;
    if (alreadySmall) {
      bitmap.close();
      return file;
    }
    const scale =
      longEdge > INBOUND_ARRIVAL_LABEL_SCAN_MAX_LONG_EDGE
        ? INBOUND_ARRIVAL_LABEL_SCAN_MAX_LONG_EDGE / longEdge
        : 1;
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext("2d");
    if (context == null) {
      bitmap.close();
      return file;
    }
    context.drawImage(bitmap, 0, 0, width, height);
    bitmap.close();
    const blob = await new Promise<Blob | null>((resolve) => {
      canvas.toBlob(resolve, "image/jpeg", INBOUND_ARRIVAL_LABEL_SCAN_JPEG_QUALITY);
    });
    if (blob == null) return file;
    return new File([blob], buildDownscaledFilename(), { type: "image/jpeg" });
  } catch {
    return file;
  }
}
